export const authMixin = {
  computed: {
    isAuth() {
      return this.$cookies.get('accessToken');
    }
  }
};